module.exports = __webpack_public_path__ + "img/0.d618d1a2.png";